import React from 'react';
import * as R from 'ramda';
import { bool, func, shape } from 'prop-types';
import Destinations from '../../edit/destinations/Destinations';
import DestinationsAccordion from '../../components/DestinationsAccordion';

const LcnsTab = ({ customerAuth, setCustomerAuth, validation, setValidation, isEditMode }) => {
  return (
    <div>
      {isEditMode ? (
        <Destinations
          info={customerAuth}
          setInfo={setCustomerAuth}
          setValidation={setValidation}
          validation={validation}
        />
      ) : (
        <DestinationsAccordion
          defaultExpanded
          destinations={customerAuth.loadingControlNumbers}
          showItn={R.or(
            R.equals(customerAuth.authorizationType, 'ONETIME'),
            R.equals(customerAuth.authorizationType, 'ONELOAD')
          )}
        />
      )}
    </div>
  );
};
LcnsTab.propTypes = {
  customerAuth: shape({}).isRequired,
  isEditMode: bool.isRequired,
  setCustomerAuth: func.isRequired,
  setValidation: func.isRequired,
  validation: shape({}).isRequired,
};

export default LcnsTab;
